import { Map } from 'immutable';
import {actionTypes as actionTypes} from '../../actions/ShipmentPage/shipmentPageActions';

let defaultState = {
  loading: false,
  shipmentId: null,
};

export default function (state = Map(defaultState), action) {
  switch (action.type) {
    case actionTypes.SHIPMENT_PAGE_SET_SHIPMENT_ID:
      return state.set('shipmentId', action.payload);
    case actionTypes.SHIPMENT_PAGE_UNMOUNT:
      return Map(defaultState)
    default:
      return state;
  }
}
